import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import MobileDeviceProtection from 'partial/OfferManager/modules/CashPerks/MobileDeviceProtection';
import RefundProtection from 'partial/OfferManager/modules/CashPerks/RefundProtection';
import React from 'react';

const CashPerks = props => {
  return (
    <FlexContainer className="flex-row flex-tablet-col padB24 m-padB0">
      <MobileDeviceProtection />
      <RefundProtection />
    </FlexContainer>
  );
};

export default CashPerks;
